import React from 'react';
import { Typography, Space } from 'antd';

const { Text } = Typography;

const DonutChartSimple = ({ data, title }) => {
    // data: [{ label: 'Paid', value: 70, color: '#52c41a' }, ...]
    const total = data.reduce((acc, curr) => acc + curr.value, 0);
    let cumulativePercent = 0;

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '24px', padding: '12px 0' }}>
            <div style={{ position: 'relative', width: '120px', height: '120px' }}>
                <svg viewBox="0 0 36 36" style={{ transform: 'rotate(-90deg)' }}>
                    {data.map((segment, idx) => {
                        const percent = (segment.value / total) * 100;
                        const dashArray = `${percent} ${100 - percent}`;
                        const dashOffset = -cumulativePercent;
                        cumulativePercent += percent;

                        return (
                            <circle
                                key={idx}
                                cx="18"
                                cy="18"
                                r="15.915"
                                fill="transparent"
                                stroke={segment.color}
                                strokeWidth="3.5"
                                strokeDasharray={dashArray}
                                strokeDashoffset={dashOffset}
                            />
                        );
                    })}
                </svg>
                <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    textAlign: 'center'
                }}>
                    <Text strong style={{ fontSize: '18px', display: 'block' }}>{total}</Text>
                    <Text type="secondary" style={{ fontSize: '10px' }}>TOTAL</Text>
                </div>
            </div>
            <div style={{ flex: 1 }}>
                {data.map((segment, idx) => (
                    <div key={idx} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '4px' }}>
                        <Space size={4}>
                            <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: segment.color }} />
                            <Text size="small" type="secondary">{segment.label}</Text>
                        </Space>
                        <Text strong size="small">{segment.value}</Text>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default DonutChartSimple;
